/*
 * @Author: lzy
 * @Date: 2022-01-11 10:26:00
 * @LastEditTime: 2022-01-12 11:32:15
 * @LastEditors: lzy
 * @Description: 通过和取消通过按钮
 * @FilePath: \xjmediacloud\app\editingCenter\directive\editListPart\isPassButton\isPassButton.js
 */
angular.module('isPassButtonModule', []).directive('isPassButton', ['newMediaService',
    function(newMediaService) {
        return {
            scope: {
                media: '@',
                rights: '=',
                selectedArray: '=',
                callback: '&'
            }, // 继承作用域
            restrict: 'EA',
            templateUrl: './editingCenter/directive/editListPart/isPassButton/index.html',
            replace: true,
            link: function($scope) {

                /**
                 * [isPass description] 通过和取消通过按钮函数
                 *
                 * @param {[type]} flag   [flag description] 通过/取消通过 true/false
                 *
                 * @return {[type]}   [return description]
                 */
                $scope.isPass = function(flag) {
                    $scope.$parent.loadingPromise = newMediaService.isPass($scope.selectedArray, flag).then(function (data) {
                        $scope.callback();
                    });
                };
            },
        };
    },
]);
